/**
 * @format
 * @flow strict-local
 */

// DEPENDENCIES

import PropTypes from "prop-types";
import React, {
	useRef
} from "react";

import {
	ComponentWrapper,
	ErrorWrapper,
	LabelWrapper
} from "./InputWrapper.styled";

import useDimensions from "../../hooks/dimensions";

// INIT

const propTypes = {
	direction: PropTypes.oneOf([
		"auto",
		"horizontal", 
		"vertical"
	]),
	error: PropTypes.node,
	help: PropTypes.node,
	htmlFor: PropTypes.string,
	label: PropTypes.node,
	labelDescription: PropTypes.string
};
const defaultProps = {
	direction: "vertical"
};

// COMPONENT

const InputWrapper = (props) => {
	const inputWrapperRef = useRef();

	const dimensions = useDimensions(inputWrapperRef);

	// Render

	/**
	 * render - ...
	 */
	const render = () => {
		let direction;
		let errorContent;
		let helpContent;
		let labelContent;
		let labelDescriptionContent;

		if(props.error) {
			errorContent = (
				<ErrorWrapper>
					{props.error}
				</ErrorWrapper>
			);
		} else {
			if(props.help) {
				helpContent = (
					<p>
						{props.help}
					</p>
				);
			}
		}

		if(props.label) {
			let labelWrapperProps = {};

			if(props.htmlFor) {
				labelWrapperProps.htmlFor = props.htmlFor;
			}

			labelContent = (
				<LabelWrapper
					{...labelWrapperProps}
					>
					{props.label}
				</LabelWrapper>
			);
		}

		if(props.labelDescription) {
			labelDescriptionContent = (
				<small>
					{props.labelDescription}
				</small>
			);
		}

		switch(props.direction) {
			case "auto":
				if(dimensions) {
					if(dimensions.width > 500) {
						direction = "horizontal";
					} else {
						direction = "vertical";
					}
				}
			break;
			default:
				direction = props.direction;
			break;
		}

		return (
			<ComponentWrapper
				direction={direction}
				ref={inputWrapperRef}
				>
				<div>
					{labelContent}
					{labelDescriptionContent}
				</div>
				<div>
					{props.children}
					{helpContent}
					{errorContent}
				</div>
			</ComponentWrapper>
		);
	};

	return render();
};

InputWrapper.propTypes = propTypes;
InputWrapper.defaultProps = defaultProps;

// EXPORT

export default InputWrapper;
